import Vue from 'vue'
import VueRouter from 'vue-router'

import MainPage from '../pages/center/centerIndex.vue'
import LoginPage from '../pages/memberLogin.vue'
import MemberForm from '../pages/userCheck.vue'
import CarUse from '../pages/subPage/page/subPage2/subPage2.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "홈",
    component: MainPage,
  },
  // {
  //   path: "/popup",
  //   name: "팝업창",
  //   component: () => import("../pages/myPage/mainPopup/mainPopupFirst.vue"),
  // },
  {
    path: "/404",
    name: "error",
    component: () => import("@/pages/failPage.vue"),
  },
  {
    path: "/login",
    name: "로그인",
    component: LoginPage,
  },
  {
    path: "/user/key_alter",
    name: "메일확인",
    component: () => import("../pages/subPage/step/emailCheck/userCheck.vue"),
    props: true,
    children: [
      {
        path: "success",
        name: "메일 인증성공",
        component: () => import("../pages/subPage/step/emailCheck/submitUser.vue"),
      },
      {
        path: "/error",
        name: "메일 인증실패",
        component: () => import("../pages/subPage/step/emailCheck/errorUser.vue"),
      },
    ],
  },
  {
    path: "/admin/key_alter",
    name: "사업자 메일확인",
    component: () => import("../pages/subPage/step/emailCheck/adminCheck.vue"),
    props: true,
  },
  {
    path: "/admin/emailError",
    name: "사업자 메일 인증실패",
    component: () => import("../pages/subPage/step/emailCheck/errorAdmin.vue"),
  },
  {
    path: "/search-id",
    name: "아이디찾기",
    component: () => import("../pages/subPage/step/configPhoneNum/searchMemberId.vue"),
  },
  {
    path: "/success-search-id",
    name: "아이디찾기성공",
    component: () => import("../pages/subPage/step/configPhoneNum/searchSuccessId.vue"),
  },
  {
    path: "/search-password",
    name: "비밀번호찾기",
    component: () => import("../pages/subPage/step/configPhoneNum/searchMemberPassword.vue"),
  },
  {
    path: "/choose-id",
    name: "비밀번호아이디찾기",
    component: () => import("../pages/subPage/step/configPhoneNum/searchSuccessPasswordId.vue"),
  },
  {
    path: "/rewrite-password",
    name: "비밀번호재설정",
    component: () => import("../pages/subPage/step/configPhoneNum/searchSuccessPassword.vue"),
  },
  {
    path: "/ipin-process-id",
    name: "아이핀전달아이디",
    component: () => import("../pages/subPage/step/all_nice/niceIpinProcessId.vue"),
  },
  {
    path: "/ipin-process-password",
    name: "아이핀전달비밀번호",
    component: () => import("../pages/subPage/step/all_nice/niceIpinProcessPassword.vue"),
  },
  {
    path: "/ipin-process-member",
    name: "아이핀전달회원",
    component: () => import("../pages/subPage/step/all_nice/niceIpinProcessMember.vue"),
  },
  {
    path: "/phone-success",
    name: "나이스성공",
    component: () => import("../pages/subPage/step/existUser/existPhoneUse/existPhoneSuccess.vue"),
  },
  {
    path: "/phone-fail",
    name: "나이스실패",
    component: () => import("../pages/subPage/step/existUser/existPhoneUse/existPhoneFail.vue"),
  },
  {
    path: "/member",
    name: "회원가입",
    component: MemberForm,
    children: [
      {
        path: "member-old-new",
        name: "회원선택",
        component: () => import("../pages/subPage/step/memberForm/memberNewOldCheck.vue"),
      },
      {
        path: "user-check",
        name: "사용자 권한",
        component: () => import("../pages/subPage/step/memberForm/memberCheck.vue"),
      },
      {
        path: "user-member",
        name: "일반 회원가입",
        component: () => import("../pages/subPage/step/memberForm/userPage.vue"),
        children: [
          {
            path: "user-step1",
            name: "약관동의",
            component: () => import("../pages/subPage/step/step1/userStep1.vue"),
            props: true,
          },
          {
            path: "user-step2",
            name: "본인인증",
            component: () => import("../pages/subPage/step/step2/userStep2.vue"),
            children: [
              {
                path: "phone-check",
                name: "핸드폰 인증",
                component: () => import("../pages/subPage/step/configUser/phoneConfig.vue"),
              },
              {
                path: "email-check",
                name: "이메일 인증",
                component: () => import("../pages/subPage/step/configUser/emailConfig.vue"),
                props: true,
              },
              {
                path: "ipin-success-new",
                name: "아이핀인증성공",
                component: () => import("../pages/subPage/step/all_nice/niceIpinResult.vue"),
              },
              {
                path: "ipin-process",
                name: "아이핀중간",
                component: () => import("../pages/subPage/step/all_nice/niceIpinProcessId.vue"),
              },
            ],
          },
          {
            path: "user-step3",
            name: "회원정보",
            component: () => import("../pages/subPage/step/step3/userStep3.vue"),
          },
          {
            path: "user-step4",
            name: "회원가입 완료",
            component: () => import("../pages/subPage/step/memberShipSubmit.vue"),
          },
        ],
      },
      {
        path: "admin-member",
        name: "사업자 회원가입",
        component: () => import("../pages/subPage/step/memberForm/adminPage.vue"),
        children: [
          {
            path: "admin-step1",
            name: "사업자 약관동의",
            component: () => import("../pages/subPage/step/step1/adminStep1.vue"),
          },
          {
            path: "admin-step2",
            name: "사업자 본인인증",
            component: () => import("../pages/subPage/step/step2/adminStep2.vue"),
            children: [
              {
                path: "email-admin",
                name: "사업자 이메일 인증",
                component: () => import("../pages/subPage/step/configUser/emailAdmin.vue"),
              },
              {
                path: "phone-admin",
                name: "사업자 핸드폰 인증",
                component: () => import("../pages/subPage/step/configUser/phoneConfig.vue"),
              },
            ],
          },
          {
            path: "admin-step3",
            name: "사업자 회원정보",
            component: () => import("../pages/subPage/step/step3/adminStep3.vue"),
          },
          {
            path: "admin-step4",
            name: "사업자 회원가입 완료",
            component: () => import("../pages/subPage/step/memberShipSubmit.vue"),
          },
        ],
      },
      {
        path: "exist-member",
        name: "기존회원수정",
        component: () => import("../pages/subPage/step/memberForm/existMemberPage.vue"),
        children: [
          {
            path: "check-exist",
            name: "인증문구확인",
            component: () => import("../pages/subPage/step/existUser/existUserCheck.vue"),
          },
          {
            path: "rewrite-exist",
            name: "기존회원정보",
            component: () => import("../pages/subPage/step/existUser/existRewriteUser.vue"),
          },
          {
            path: "exist-submit",
            name: "회원수정완료",
            component: () => import("../pages/subPage/step/existUser/existUserSubmit.vue"),
          },
          {
            path: "login-exist",
            name: "기존회원번호확인",
            component: () => import("../pages/subPage/step/existUser/existPhoneUse/existPhoneCheck.vue"),
          },
          {
            path: "exist-nice",
            name: "나이스인증성공",
            component: () => import("../pages/subPage/step/existUser/existPhoneUse/existPhoneSuccess.vue"),
          },
          {
            path: "exist-nice-fail",
            name: "나이스인증실패",
            component: () => import("../pages/subPage/step/existUser/existPhoneUse/existPhoneFail.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/my-page",
    name: "마이페이지",
    component: () => import("../pages/myPage/myPage2.vue"),
    // meta: {requiresAuth: true},
    children: [
      {
        path: "car-sign",
        name: "차량 등록 관리",
        component: () => import("../pages/myPage/center/car/carSign.vue"),
        props: true,
      },
      {
        path: "car-discount",
        name: "차량 할인 관리",
        component: () => import("../pages/myPage/center/car/discount/carSignDiscount.vue"),
        props: true,
      },
      {
        path: "rewrite",
        name: "차량 수정",
        component: () => import("../pages/myPage/center/car/carReWrite.vue"),
        props: true,
      },
      {
        path: "carCheckInfo",
        name: "차량 정보",
        component: () => import("../pages/myPage/center/car/carInfo.vue"),
        props: true,
      },
      {
        path: "carInfo",
        name: "차량등록안내",
        component: () => import("../pages/myPage/center/car/carSignInfo.vue"),
      },
      {
        path: "carDiscountInfo",
        name: "차량할인안내",
        component: () => import("../pages/myPage/center/car/discount/carSignDiscountInfo.vue"),
      },
      {
        path: "carDiscountCheckInfo",
        name: "할인 정보",
        component: () => import("../pages/myPage/center/car/discount/carDiscountInfo.vue"),
      },
      {
        path: "commutation-ticket",
        name: "정기권 등록 현황",
        component: () => import("../pages/myPage/myPageSeason.vue"),
        children: [
          {
            path: "use-breakdown",
            name: "정기권 사용 내역",
            component: () => import("../pages/myPage/center/seasonTicket/commutationCenter.vue"),
            props: true,
          },
          {
            path: "car-payment",
            name: "정기권 구매 내역",
            component: () => import("../pages/myPage/center/seasonTicket/commPayment.vue"),
            props: true,
          },
          {
            path: "app-check",
            name: "정기권 신청 내역",
            component: () => import("../pages/myPage/center/seasonTicket/commCheck.vue"),
            props: true,
          },
          {
            path: "payment",
            name: "결제",
            component: () => import("../pages/myPage/center/paymentTicket.vue"),
          },
          {
            path: "paymentSubmit",
            name: "결제완료",
            component: () => import("../pages/myPage/center/paymentSubmit.vue"),
          },
          {
            path: "paymentCancel",
            name: "결제취소",
            component: () => import("../pages/myPage/center/cancelTicket.vue"),
          },
          {
            path: "*",
            component: () => import("@/pages/failPage.vue"),
          },
        ],
      },
      {
        path: "time-buy",
        name: "시간권 등록 현황",
        component: () => import("../pages/myPage/myPageTime.vue"),
        children: [
          {
            path: "use-timeBreak",
            name: "시간권 사용 내역",
            component: () => import("../pages/myPage/center/timeTicketCheck.vue"),
          },
          {
            path: "app-timeCheck",
            name: "시간권 구매 내역",
            component: () => import("../pages/myPage/center/timeTicketPayment.vue"),
          },
          {
            path: "*",
            component: () => import("@/pages/failPage.vue"),
          },
        ],
      },
      {
        path: "member-re",
        name: "회원정보 수정",
        component: () => import("../pages/myPage/center/memberRe.vue"),
        props: true,
      },
      {
        path: "user-out",
        name: "회원 탈퇴",
        component: () => import("../pages/myPage/center/memberDelete.vue"),
        props: true,
      },
      {
        path: "user-delete",
        name: "회원 탈퇴 확인",
        component: () => import("../pages/myPage/center/memberDeleteCheck.vue"),
      },
      {
        path: "*",
        component: () => import("@/pages/failPage.vue"),
      },
    ],
  },
  {
    path: "/info",
    name: "사업소개",
    component: () => import("../pages/subPage/page/subPage1/subPage1.vue"),
    children: [
      {
        path: "parking",
        name: "주차장 소개",
        component: () => import("../pages/subPage/page/subPage1/subCenter1/parkingLotInfoAll.vue"),
      },
      {
        path: "group",
        name: "담당부서 안내",
        component: () => import("../pages/subPage/page/subPage1/subCenter1/memberInfoAll.vue"),
      },
      {
        path: "*",
        component: () => import("@/pages/failPage.vue"),
      },
    ],
  },
  {
    path: "/car-use",
    name: "이용안내",
    component: CarUse,
    redirect: () => import("../pages/subPage/page/subPage2/subPage2-1.vue"),
    children: [
      {
        path: "coin",
        name: "주차요금 안내",
        component: () => import("../pages/subPage/page/subPage2/subPage2-1.vue"),
        children: [
          {
            path: "coin-info",
            name: "요금안내",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/parkingCoinInfoCenter.vue"),
          },
          {
            path: "coin-discount",
            name: "할인안내",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/parkingCoinDiscountCenter.vue"),
          },
          {
            path: "default-coin",
            name: "미납주차 요금안내",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/subCenter2-2.vue"),
          },
          {
            path: "*",
            component: () => import("@/pages/failPage.vue"),
          },
        ],
      },
      {
        path: "facility",
        name: "시설현황",
        component: () => import("../pages/subPage/page/subPage2/subPage2-2.vue"),
        children: [
          {
            path: "on-situation",
            name: "노상주차장 현황",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/parkingLotUpGround.vue"),
          },
          {
            path: "out-situation",
            name: "노외주차장 현황",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/parkingLotOutGround.vue"),
          },
          {
            path: "school-situation",
            name: "학교주차장 현황",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/subCenter2-5.vue"),
          },
        ],
      },
      {
        path: "commutation",
        name: "정기권 신청",
        component: () => import("../pages/subPage/page/subPage2/subCenter2/seasonCheckInfoCenter.vue"),
        children: [
          {
            path: "main",
            name: "확인",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/cmtTicket/cmtMapInfo.vue"),
            props: true,
          },
          // {
          //   path: "check",
          //   name: "신청",
          //   component: () => import("../pages/subPage/page/subPage2/subCenter2/cmtTicket/cmtCheck.vue"),
          //   props: true,
          // },
          {
            path: "check",
            name: "신청",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/seasonProduct/seasonProductCheck.vue"),
            props: true,
          },
          {
            path: "submit",
            name: "신청완료",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/cmtTicket/cmtSubmit.vue"),
          },
          {
            path: "cancel",
            name: "취소",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/cmtTicket/stopPayment.vue"),
          },
          {
            path: "*",
            component: () => import("@/pages/failPage.vue"),
          },
        ],
      },
      {
        path: "timeTicket",
        name: "시간권 구매",
        component: () => import("../pages/subPage/page/subPage2/subCenter2/timeCheckInfoCenter.vue"),
        children: [
          {
            path: "timeTicket",
            name: "정보",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/timeTicket/timeMapInfo.vue"),
          },
          {
            path: "timePayment",
            name: "시간권 결제",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/timeTicket/timeCheck.vue"),
          },
          {
            path: "timeSubmit",
            name: "결제 완료",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/timeTicket/timeSubmit.vue"),
          },
          {
            path: "timeCancel",
            name: "시간권 취소",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/timeTicket/timeStopPayment.vue"),
          },
          {
            path: "*",
            component: () => import("@/pages/failPage.vue"),
          },
        ],
      },
      {
        path: "parkingInfo",
        name: "주차장 안내",
        component: () => import("../pages/subPage/page/subPage2/subCenter2/parkingInformation.vue"),
        children: [
          {
            path: "announcement",
            name: "안내사항",
            component: () => import("../pages/subPage/page/subPage2/subCenter2/parking/parkingInfo.vue"),
          },
        ],
      },
      {
        path: "personalInformation",
        name: "개인정보 처리방침",
        component: () => import("../pages/subPage/page/subPage2/subCenter2/personalInformation/personalInformation.vue"),
      },
      {
        path: "*",
        component: () => import("@/pages/failPage.vue"),
      },
    ],
  },
  {
    path: "/park-info",
    name: "주차정보",
    component: () => import("../pages/subPage/page/subPage3/subPage3.vue"),
    children: [
      {
        path: "real-time",
        name: "실시간 주차정보",
        component: () => import("../pages/subPage/page/subPage3/subCenter3/subCenter3-2.vue"),
        children: [
          {
            path: "timeInfo",
            name: "실시간정보",
            component: () => import("../pages/subPage/page/subPage3/subCenter3/timeStamp/timeStampInfo.vue"),
          },
        ],
      },
      {
        path: "default-check",
        name: "미납정보 조회",
        component: () => import("../pages/subPage/page/subPage3/subCenter3/subCenter3-1.vue"),
        children: [
          {
            path: "defaultInfo",
            name: "미납정보",
            component: () => import("../pages/subPage/page/subPage3/subCenter3/defaultPay/defaultPayInfo.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/customer",
    name: "고객지원",
    component: () => import("../pages/subPage/page/subPage4/subPage4.vue"),
    children: [
      {
        path: "notice",
        name: "공지 사항",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/tableFirst.vue"),
      },
      {
        path: "noticeInfo",
        name: "공지 사항 내용",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/notice/noticeBoardInfo.vue"),
      },
      {
        path: "noticeWrite",
        name: "공지 사항 작성",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/notice/noticeWriteBoard.vue"),
      },
      {
        path: "noticeReWrite",
        name: "공지 사항 수정",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/notice/noticeReWriteBoard.vue"),
      },
      {
        path: "frequently",
        name: "자주하는 질문",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/tablesSecond.vue"),
      },
      {
        path: "faqInfo",
        name: "자주하는 질문 내용",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/faq/faqBoardInfo.vue"),
      },
      {
        path: "faqWrite",
        name: "자주하는 질문 작성",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/faq/faqWriteBoard.vue"),
      },
      {
        path: "faqReWrite",
        name: "자주하는 질문 수정",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/faq/faqReWriteBoard.vue"),
      },
      {
        path: "question",
        name: "문의 사항",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/tableThird.vue"),
      },
      {
        path: "request",
        name: "차량변경/환불요청",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/tableRequest.vue"),
      },
      {
        path: "requestWrite",
        name: "차량변경/환불신청 작성",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/request/RequestWriteBoard.vue")
      },
      {
        path: "requestInfo",
        name: "차량변경/환불신청 내용",
        component:() => import('../pages/subPage/page/subPage4/subCenter4/request/ReqeustBoardInfo.vue')
      },
      {
        path: "requestRewrite",
        name: "차량변경/환불신청 수정",
        component: () => import('../pages/subPage/page/subPage4/subCenter4/request/RequestBoardRewrite.vue')
      },
      {
        path: "boardWrite",
        name: "문의하기",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/qna/qnaWriteBoard.vue"),
      },
      {
        path: "boardReWrite",
        name: "수정하기",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/qna/reWriteQnaBoard.vue"),
      },
      {
        path: "boardInfo",
        name: "문의내용",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/qna/qnaBoardInfo.vue"),
      },
      {
        path: "adminWrite",
        name: "답변하기",
        component: () => import("../pages/subPage/page/subPage4/subCenter4/qna/answerBoardInfo.vue"),
      },
      {
        path: "*",
        component: () => import("@/pages/failPage.vue"),
      },
    ],
  },
  {
    path: "/siteMap",
    name: "사이트맵",
    component: () => import("../pages/subPage/page/siteMap/siteMapInfo.vue"),
    children: [
      {
        path: "siteMapInfo",
        name: "사이트맵정보",
        component: () => import("../pages/subPage/page/siteMap/siteMapMain.vue"),
      },
      {
        path: "*",
        component: () => import("@/pages/failPage.vue"),
      },
    ],
  },
  {
    path: "*",
    component: () => import("@/pages/failPage.vue"),
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL ,
  fallback: true,
  routes
})

export default router
